import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { WidgetDTO } from '@topconagriculture/dashboard/build/api/widget/widget.types';
import { getAuthProps } from '@topconagriculture/auth';

import { notificationError } from '../../../core/helpers/utils/notificationUtils';
import { getFarmsListRequest } from '../farms/farms.actions';
import { composeErrorMessage } from '../../../core/helpers/utils/utils';
import api from '../../../core/api';
import { fetchWidgets } from './dashboard.actions';

export function* fetchWidgetListSaga() {
  try {
    const { userId } = yield select(getAuthProps);
    const result: WidgetDTO[] = yield call(api.dashboard.getWidgetList, userId);

    yield put(
      fetchWidgets.done({
        params: {},
        result,
      }),
    );
  } catch (err) {
    yield put(notificationError(composeErrorMessage(err)));
  }
}

export function* watchDashboardSaga() {
  yield all([yield takeLatest(getFarmsListRequest.started, fetchWidgetListSaga)]);
}
